<section class="toggle-form unassign-training-item-group-slider"
    [ngClass]="{ active: isUnAssignTrainingItemGroupSliderOpen }">
    <div class="formwrap">
        <div class="header">
            <h2>
                <b>{{ unAssignTrainingItemGroupHeaderText }}</b>
            </h2>
            <p-button appPreventDoubleClick styleClass="p-button-text" id="unAssignTrainingItemGroupCloseBtn"
                type="button" label="Close" (debounceClick)="openConfirmationModal()"></p-button>
        </div>
        <div class="mt-3">
            <div class="unassign-training-item-group-container">
                <div class="fields-row">
                    <div class="field">
                        <bpt-dropdown label="Training Item Group(s)" [options]="trainingItemGroups"
                            id="unassignTrainingItemGroups" [multiSelect]="true" [editable]="false" [showClear]="true"
                            [showFilter]="true" [valueField]="valueField" [labelField]="labelField"
                            [(ngModel)]="selectedTrainingItemGroups" (dropdownChange)="enableOrDisableUnAssignTrainingItemGroupsSaveBtn()">
                        </bpt-dropdown>
                    </div>
                </div>
                <div>
                    <p-button appPreventDoubleClick label="Save" type="submit"
                        id="unAssignTrainingItemGroupsSaveBtn" class="align-right"
                        styleClass="bpt-button-compact" (debounceClick)="unAssignTrainingItemGroups()"
                        [disabled]="!isSaveEnabled">
                    </p-button>
                </div>
            </div>
        </div>
    </div>
</section>
